import { APIMethod, fetchData } from "@client";

export async function removeCouponQuery() {
  return await fetchData("/company/coupon", APIMethod.DELETE);
}
